import firebase from '../../firebase/firebase';
const db = firebase.firestore();

export default {
    namespaced: true,
    state: {
        menus: [],
    },
    actions: {
        async fetchMenus ({ commit }) {
            const menus = [];
            const snaps = await db.collection('menus').get();
            snaps.forEach(ref => {
                menus.push({ id: ref.id, ...ref.data(), used: false }); // used is for UI
            });
            commit('setMenus', menus);
        },
    },
    mutations : {
        setMenus (state, payload) {
          state.menus = payload;
        },
        setMenusAsUsed (state, menu) {
            state.menus.find(m => m.id === menu.id).used = true;
        },
    }
}  